import { useId, useState } from "react";
import Icon from "./Icon";

/**
 * Acordeón accesible: cada disparador es un botón con aria-expanded
 * y aria-controls, y el panel se retira del DOM al cerrarse para que
 * los lectores de pantalla no lean contenido oculto.
 */
export default function Accordion({ items, allowMultiple = false }) {
  const baseId = useId();
  const [open, setOpen] = useState([]);

  const toggle = (id) => {
    setOpen((prev) => {
      if (prev.includes(id)) return prev.filter((item) => item !== id);
      return allowMultiple ? [...prev, id] : [id];
    });
  };

  return (
    <div className="fsg-accordion">
      {items.map((item, index) => {
        const id = item.id ?? String(index);
        const isOpen = open.includes(id);
        const panelId = `${baseId}-panel-${id}`;
        const buttonId = `${baseId}-button-${id}`;

        return (
          <div className="fsg-accordion__item" key={id}>
            <h3 style={{ margin: 0 }}>
              <button
                type="button"
                id={buttonId}
                className="fsg-accordion__trigger"
                aria-expanded={isOpen}
                aria-controls={panelId}
                onClick={() => toggle(id)}
              >
                <span>{item.question}</span>
                <span className="fsg-accordion__icon" aria-hidden="true">
                  <Icon name="plus" />
                </span>
              </button>
            </h3>
            {isOpen && (
              <div
                className="fsg-accordion__panel"
                id={panelId}
                role="region"
                aria-labelledby={buttonId}
              >
                <p>{item.answer}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}
